/* eslint-disable */
import flatpickr from "flatpickr";
import $ from "jquery";
import mask from "jquery-mask-plugin";

import "../vendor/datepicker/en-NZ.js";
import "../vendor/datepicker/datepicker.js";

const DocumentLibrary = () => {
  const dateFrom = $("#df");
  const dateTo = $("#dt");

  dateTo.focusin(() => {
    dateTo.attr("placeholder", "dd/mm/yyyy");
    dateTo.mask("00/00/0000");
  });

  dateFrom.focusin(() => {
    dateFrom.attr("placeholder", "dd/mm/yyyy");
    dateFrom.mask("00/00/0000");
  });

  dateFrom.focusout(() => {
    dateFrom.attr("placeholder", "From");
  });

  dateTo.focusout(() => {
    dateTo.attr("placeholder", "To");
  });

  /**
   * Set up selects
   */

  const dropdownFilters = document.querySelectorAll(".dropdown-filter");
  const dropdownList = [].slice.call(dropdownFilters);

  const dropdownTab = () => {
    const dropdown = $(".dropdown-filter--active");
    const focusableEls = dropdown
      .find(".dropdown-list")
      .find(".checkbox-toggle");
    const lastFocusableEls = focusableEls.last()[0];
    const heading = $(".dropdown-filter--active > .dropdown-heading");

    $(lastFocusableEls).focusout(function () {
      dropdown.focus();
      if (dropdown.attr("aria-label") === "Document Type") {
        window.scrollBy(0, -50);
      }
    });

    heading.keyup(function (e) {
      if ($(e.target).is(":focus") && e.which == 13) {
        if ($(e.target).parent().hasClass('dropdown-filter--active')) {
          $(e.target).parent().removeClass('dropdown-filter--active');
        } else {
          $('.dropdown-filter').removeClass('dropdown-filter--active');
          $(e.target).parent().addClass('dropdown-filter--active');
        }
      }
    });
  };

  const createSelects = () => {

    $(document).on("click", function(e) {
        if ( $(e.target).hasClass("dropdown-heading")) {
          if ($(e.target).parent().hasClass('dropdown-filter--active')) {
            $(e.target).parent().removeClass('dropdown-filter--active');
          } else {
            $('.dropdown-filter').removeClass('dropdown-filter--active');
            $(e.target).parent().addClass('dropdown-filter--active');
            $(e.target).focus();
            dropdownTab();
          }

          return;
        }

        if ($(window).outerWidth() > 767) {
          if ($('.dropdown-filter--active').length && !$(e.target).closest('.dropdown-filter--active').length) {
            $('.dropdown-filter').removeClass('dropdown-filter--active');
            return;
          }
        }
    });

    $(document).keypress(function(e) {
      if (e.which == 13) {
        dropdownList.forEach((el) => {
          dropdownTab();
          const dropdown = $(el);
          if (dropdown.is(":focus")) {
            e.preventDefault();
            dropdown.toggleClass("dropdown-filter--active");
          }
        });
      }
    });

    document.addEventListener('keydown', e => {
      const keyCode = e.keyCode;
      if (keyCode == 27) {
        dropdownList.forEach((el) => {
          dropdownTab();
          const dropdown = $(el);
          if (dropdown.hasClass("dropdown-filter--active")) {
            e.preventDefault();
            dropdown.removeClass("dropdown-filter--active");
          }
        });
      }
    });

    $(".document-filters--mobile .field--date-published").on(
      "click",
      function() {
        $(this).toggleClass("active");
      }
    );
  };

  /**
   * Set up datePickers
   */
  const setupDatePickers = () => {
    const datepickers = [].slice.call(document.querySelectorAll(".datepicker"));

    if (datepickers) {
      datepickers.forEach(el => {
        $(el).datepicker({
          theme: 'bootstrap',
          inputFormat: ["dd/MM/yyyy"],
          outputFormat: 'dd/MM/yyyy'
        });
      });
    }
  };

  // Initialise our lib
  const init = () => {
    setupDatePickers();
    createSelects();
  };

  if ($(".no-document-results")[0]) {
    $(".no-results-title").html("no");
  }

  // Handle our mobile filter dropdowns
  $(document).on("click", ".filter-heading", function() {
    $(this).toggleClass("filter-heading--active");
    $(".category-filter-holder").toggleClass("category-filter-holder--active");
  });

  $(document).on("click", ".category-heading", function() {
    $(this)
      .parent()
      .toggleClass("category-filter-item--active");
  });

  /**
   * Check to see if we're on the document page
   * If so then initialise everything else
   */
  if (
    document.body.classList.contains("MBIE\\PageTypes\\DocumentLibraryPage")
  ) {
    init();
  }
};

export default DocumentLibrary;

/* eslint-enable */
